// Ticket Master (#276) — gate predicate for the header "🎫 Ticket Master"
// button. Ticket Master is the in-app Help-Desk ticket research tool: type an
// invoice number and it renders a unified, glanceable timeline of what happened
// to that job across three lanes (EventLog / Time Machine change stream,
// FileMaker Schedule [DATA], FileMaker TurboQ), plus a Claude-written
// conclusion — human actions interleaved with automated-system actions, in true
// time order.
//
// Returns true ONLY when the user is logged in AND their Users document's
// `screenAccessList` contains the `"ticketMaster"` token.
//
// Access source: managed in the "Tab Access" section of UserDetailModal, which
// reads/writes `Users.screenAccessList` — the same array + pattern that gates
// Compass / Dashboard / Time Machine (#202). Not for general schedulers.
//
// Why `.includes(token)` (strict membership, same rationale as the sibling
// canAccessCompass / canAccessDashboard / canAccessTimeMachine): the token is
// either present or it isn't — no truthiness coercion — so a future schema
// change can't accidentally open the gate.

export function canAccessTicketMaster(mongoUser, tsUserDocument) {
  return (
    Boolean(mongoUser) &&
    Array.isArray(tsUserDocument?.screenAccessList) &&
    tsUserDocument.screenAccessList.includes("ticketMaster")
  );
}
